import { WILSON_PALETTE } from './wilson-brand';

/** Wilson "W" sidebar logo (45x45). */
export const WilsonSidebarLogo = () => (
  <svg
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="22.5" cy="22.5" r="22.5" fill="#fff" />
    <path
      d="M33,13.6c1.8,0,2.9,1,2.9,2.6s-1.1,2.6-2.9,2.6-2.9-1-2.9-2.6,1.2-2.6,2.9-2.6Z"
      fill={WILSON_PALETTE.accent}
    />
    <path
      d="M14.6,19.2l1.6,6.5,1.6-6.5h4.4l1.6,6.5,1.6-6.5h5.4l-4,12.3h-5.2l-1.6-6-1.6,6h-5.2l-4-12.3h5.4Z"
      fill={WILSON_PALETTE.darkNeutral}
    />
  </svg>
);

export default WilsonSidebarLogo;
